import './ccf-gif-icon.module.scss';

import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfGifIconProps extends SvgIconProps {}
/**
 * component used to display GIF icon
 * @param props - CcfGifIconProps
 * @example - <CcfGifIcon />
 * @returns SVG of GIF icon
 */
export function CcfGifIcon(props: CcfGifIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="ic_insert_gif" width="20" height="20" viewBox="0 0 20 20">
        <g id="Group_121033" data-name="Group 121033" transform="translate(1.205 1.205)">
         <g id="Rectangle_37196" data-name="Rectangle 37196" fill="#fff" stroke="#000" strokeWidth="1">
          <rect width="17.59" height="17.59" rx="3" stroke="none"/>
          <rect x="0.5" y="0.5" width="16.59" height="16.59" rx="2.5" fill="none"/>
          </g>
          <text id="GIF" transform="translate(2.112 11)" font-size="8" font-family="OpenSans-Semibold, Open Sans" font-weight="600"><tspan x="0" y="0">GIF</tspan></text>
        </g>
      </g>
    </SvgIcon>
  );
}

export default CcfGifIcon;
